<template>
	<div>
		<el-table v-if="pageInfo == 'auth'" :data="authData" style="width: 100%; height: 100%;padding-top:16px!important"
			class="user_table" border>
			<el-table-column prop="user.nick_name" label="加入人"></el-table-column>
			<el-table-column prop="pic_id" label="授权ID" width="150"></el-table-column>
			<el-table-column label="授权类型">版权内容</el-table-column>
			<el-table-column prop="png_url" label="授权内容">
				<template slot-scope="scope">
					<div class="img-wrap">
						<img :src="checkWebp ? scope.row.png_url : scope.row.webp_url" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="created_at" label="授权时间">
				<template slot-scope="scope">
					{{ new Date(scope.row.created_at).Format("yyyy-MM-dd hh:mm:ss")}}
				</template>
			</el-table-column>
			<el-table-column label="订单金额">套餐</el-table-column>
			<!-- <el-table-column prop="option" label="授权书">
				<template slot-scope="scope">
					<div class="option">
						<a href="javascript:;" @click="handleAuthDialogVisible(scope.row.id)"
							v-if="scope.row.is_authorize === 2">获取</a>
						<a href="javascript:;" @click="flag && authDownload(scope.row.pic_id)"
							v-if="scope.row.is_authorize === 1">下载</a>
					</div>
				</template>
			</el-table-column> -->
		</el-table>
		<el-table v-if="pageInfo == 'download'" :data="downData" style="width: 100%; height: 100%;"
			class="user_table" border>

			<el-table-column prop="user_name" label="下载用户昵称"></el-table-column>
			<el-table-column prop="team_name" label="团队名称"></el-table-column>
			<el-table-column prop="copyright_id" label="图片ID"></el-table-column>
			<el-table-column prop="png_url" label="授权内容">
				<template slot-scope="scope">
					<div class="img-wrap">
						<img :src="scope.row.url" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="created_at" label="下载时间">
				<template slot-scope="scope">
					{{ new Date(scope.row.created_at).Format("yyyy-MM-dd hh:mm:ss")}}
				</template>
			</el-table-column>


		</el-table>
		<div class="pages-container">
			<el-pagination hide-on-single-page id="el-page" layout="prev, pager, next" :total="total" :pager-count="5"
				prev-text="＜ 上一页" next-text="下一页 ＞" :page-size="8" @current-change="pageChange" background>
			</el-pagination>
		</div>
		<!-- 爱设计商业授权书弹窗 -->
		<div class="auth-dialog-meng" v-if="authDialogVisible">
			<div id="auth-dialog" class="auth-dialog-content">
				<img @click="authDialogVisible = false" class="close-img" src="/new/image/personalpage/close@2x.png" alt="">
				<h1>爱设计商业授权书</h1>
				<el-form label-width="136px" :model="authForm" :rules="authRules" ref="authForm">
					<el-form-item label="授权主体" class="auth-20-line">
						<el-radio-group v-model="authForm.principal" @change="principalChange">
							<el-radio label="2">企事业单位</el-radio>
							<el-radio label="1">个人</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="authForm.principal === '1'">
						<el-form-item label="主体选择">
							<el-select v-model="authForm.personNameSelected" placeholder="请选择" class="auth-el-select"
								@change="getAuthCode(authForm.personNameSelected)">
								<el-option v-for="(item, index) in personNameList" :key="index" :value="item.id" :label="item.name">
									<span v-if="item.id === -1" class="iconfont icon-add-to" style="position:relative;top:1px;"></span>
									<span>{{ item.name }}</span>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="姓名" prop="personName" v-if="authForm.personNameSelected === -1">
							<el-input v-model="authForm.personName" placeholder="请输入姓名" maxlength="50" minlength="2" type="text">
							</el-input>
						</el-form-item>
						<el-form-item label="身份证号" prop="personCode">
							<el-input v-model="authForm.personCode" placeholder="请输入身份证号"
								:disabled="authForm.personNameSelected === -1 ? false : true"></el-input>
						</el-form-item>
						<el-form-item label="联系电话" prop="personPhone" v-if="authForm.personNameSelected === -1">
							<el-input v-model="authForm.personPhone" placeholder="请输入联系电话"></el-input>
						</el-form-item>
						<el-form-item label="邮箱地址" prop="personEmail" v-if="authForm.personNameSelected === -1">
							<el-input v-model="authForm.personEmail" placeholder="请输入邮箱地址"></el-input>
						</el-form-item>
						<el-form-item label="授权说明" class="auth-20-line"
							:class="authForm.personNameSelected === -1 ? 'auth-52-line' : 'auth-32-line'">
							<p class="auth-notice">
								注意：授权书一经提交，将无法修改，请谨慎填写。
								<span v-if="authForm.personNameSelected === -1 && authPrincipalCount > 0" style="color: #333">您还能添加<span
										style="color: #7966FF"> {{ authPrincipalCount }} </span>个主体</span>
							</p>
						</el-form-item>
					</template>
					<template v-if="authForm.principal === '2'">
						<el-form-item label="主体选择">
							<el-select v-model="authForm.companyNameSelected" placeholder="请选择" class="auth-el-select"
								@change="getAuthCode(authForm.companyNameSelected)">
								<el-option v-for="(item, index) in companyNameList" :key="index" :value="item.id" :label="item.name">
									<span v-if="item.id === -2" class="iconfont icon-add-to" style="position:relative;top:1px;"></span>
									<span>{{ item.name }}</span>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="企业名称" prop="companyName" v-if="authForm.companyNameSelected === -2">
							<el-input v-model="authForm.companyName" placeholder="请输入企业名称" maxlength="50" minlength="2" type="text">
							</el-input>
						</el-form-item>
						<el-form-item label="统一社会信用代码" prop="companyCode">
							<el-input v-model="authForm.companyCode" placeholder="请输入统一社会信用代码"
								:disabled="authForm.companyNameSelected === -2 ? false : true"></el-input>
						</el-form-item>
						<el-form-item label="联系电话" prop="companyPhone" v-if="authForm.companyNameSelected === -2">
							<el-input v-model="authForm.companyPhone" placeholder="请输入联系电话"></el-input>
						</el-form-item>
						<el-form-item label="邮箱地址" prop="companyEmail" v-if="authForm.companyNameSelected === -2">
							<el-input v-model="authForm.companyEmail" placeholder="请输入邮箱地址"></el-input>
						</el-form-item>
						<el-form-item label="授权说明" class="auth-20-line"
							:class="authForm.companyNameSelected === -2 ? 'auth-52-line' : 'auth-32-line'">
							<p class="auth-notice">
								注意：授权书一经提交，将无法修改，请谨慎填写。
								<span v-if="authForm.companyNameSelected === -2 && authPrincipalCount > 0"
									style="color: #333">您还能添加<span style="color: #7966FF"> {{ authPrincipalCount }} </span>个主体</span>
							</p>
						</el-form-item>

					</template>
					<el-form-item class="btn-group">
						<el-button @click="authDialogVisible = false">取消</el-button>
						<el-button @click="authSubmimt" type="primary" :disabled="submitClicked"
							:style="{ opacity: (submitClicked ? 0.6 : 1) }">提交</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- 爱设计商业授权提交失败的弹窗 -->
		<div class="auth-dialog-meng" v-if="authFailDialogVisible">
			<div id="auth-dialog-fail" class="auth-dialog-content">
				<img @click="closeAuthFailDialog" class="close-img" src="/new/image/personalpage/close@2x.png" alt="">
				<img class="fail-img" src="/new/image/common/exfail@2.png" alt="">
				<p class="fail-text">提交失败，请重新提交</p>
				<el-button @click="closeAuthFailDialog" class="ok-btn" type="primary">好的</el-button>
			</div>
		</div>
	</div>

</template>

<script>
import { Copyright } from "@/config/axios/new_api"
export default {
	data() {
		return {
			page: 1,
			page_size: 8,
			total: 0,

			authDialogVisible: false,
			authFailDialogVisible: false, // 授权失败的弹窗
			currentAuthorizeId: 0,
			authPrincipalCount: 0,    //授权主体个数
			authForm: {
				principal: window.localStorage.getItem('type') || '2',
				companyNameSelected: parseInt(window.localStorage.getItem('company_principal_id')) || -2,
				companyName: '',
				companyCode: window.localStorage.getItem('company_code') || '',
				companyPhone: '',
				companyEmail: '',
				personNameSelected: parseInt(window.localStorage.getItem('person_principal_id')) || -1,
				personName: '',
				personCode: window.localStorage.getItem('person_code') || '',
				personPhone: '',
				personEmail: ''
			},
			authRules: {
				companyName: [{
					required: true,
					validator: (rule, value, callback) => {
						value = this.filterFn(value);
						if (value === '') {
							callback(new Error('请输入企业名称！'));
						} else if (value.length < 2) {
							callback(new Error('最少2个字符！'));
						} else if (value.length > 50) {
							callback(new Error('最多50个字符！'));
						} else {
							callback();
						}
					},
					trigger: 'blur'
				}],
				companyCode: [
					{
						required: true,
						validator: (rule, value, callback) => {
							value = this.filterFn(value);
							if (value === '') {
								callback(new Error('请输入统一社会信用代码！'));
							} else {
								value.match(/^[0-9A-Za-z]+$/) ?
									callback() : callback(new Error('请输入正确的统一社会信用代码！'));
							}
						},
						trigger: 'blur'
					}],
				companyPhone: [{
					required: true,
					validator: (rule, value, callback) => {
						value = this.filterFn(value);
						if (value === '') {
							callback(new Error('请输入联系电话！'));
						} else {
							this.staticFunc.checkMobile(value) ? callback() : callback(new Error('请输入正确的联系电话！'))
						}
					},
					trigger: 'blur'
				}],
				companyEmail: [{
					required: true,
					message: '请输入邮箱地址！',
					trigger: 'blur'
				}, {
					type: 'email',
					message: '请输入正确的邮箱地址',
					trigger: ['blur']
				}],
				personName: [{
					required: true,
					validator: (rule, value, callback) => {
						value = this.filterFn(value);
						if (value === '') {
							callback(new Error('请输入姓名！'));
						} else if (value.length < 2) {
							callback(new Error('最少2个字符！'));
						} else if (value.length > 50) {
							callback(new Error('最多50个字符！'));
						} else {
							value.match(/^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\.\s]{1,20})$/) ?
								callback() : callback(new Error('请输入正确的姓名！'));
						}
					},
					trigger: 'blur'
				}],
				personCode: [{
					required: true,
					validator: (rule, value, callback) => {
						value = this.filterFn(value);
						if (value === '') {
							callback(new Error('请输入身份证号！'));
						} else {
							value.match(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/gi) ?
								callback() : callback(new Error('请输入正确的身份证号！'));
						}
					},
					trigger: 'blur'
				}],
				personPhone: [{
					required: true,
					validator: (rule, value, callback) => {
						value = this.filterFn(value);
						if (value === '') {
							callback(new Error('请输入联系电话！'));
						} else {
							this.staticFunc.checkMobile(value) ? callback() : callback(new Error('请输入正确的联系电话！'))
						}
					},
					trigger: 'blur'
				}],
				personEmail: [{
					required: true,
					message: '请输入邮箱地址！',
					trigger: 'blur'
				}, {
					type: 'email',
					message: '请输入正确的邮箱地址',
					trigger: 'blur'
				}],
			},
			companyNameList: [],
			personNameList: [],
			flag: true,

			authData: [],
			downData: [],
		}
	},
	created() {
		this.initData(true)
	},
	watch: {
		$route(to, from) {
			if (to.query.info != from.query.info) {
				this.initData(true)
			}
		}
	},
	methods: {
		initData(init) {
			this.pageInfo = this.$route.query.info;
			if(init) {
				this.page = 1;
				this.total = 0;
				this.downData = [];
				this.authData = [];
			}
			if (this.pageInfo === 'auth') {
				this.getAuthData();
			} else if (this.pageInfo === 'download') {
				this.getDownData();
			}
		},
		// 获取样图下载记录
		getDownData() {
			Copyright.getDemoList({ page: this.page, page_size: this.page_size }).then(res => {
				if (res.status == 1) {
					this.downData = res.data.list;
					this.total = res.data.pagination.total;
				}
			})
		},
		// 获取授权记录
		getAuthData() {
			Copyright.getAuthorizeList({ page: this.page, page_size: this.page_size }).then(res => {
				if (res.status == 1) {
					this.authData = res.data.list;
					this.total = res.data.pagination.total;
				}
			})
		},
		// 页码改变
		pageChange(val) {
			this.page = val;
			this.initData()
		},
		//  点击获取按钮
		handleAuthDialogVisible(id) {
			this.currentAuthorizeId = id;
			// 初始化数据
			this.authForm.principal = window.localStorage.getItem('type') || "2";
			this.authDialogVisible = true;
			this.getAuthPrincipalList(this.authForm.principal)
		},
		//  获取授权主体列表
		getAuthPrincipalList() {
			let typeValue = this.authForm.principal;
			Copyright.getPrincipalList({ type: typeValue }).then(res => {
				if (res.status == 1) {
					this.authPrincipalCount = res.data.count;
					if (typeValue == 2) {
						this.companyNameList = res.data.data;
						// 判断列表中是否需要新建功能
						if (this.authPrincipalCount > 0) {
							this.companyNameList.push({
								id: -2,
								name: '新增企事业主体',
								code: ''
							})
						}
						// 初始化主体选择和信用代码(有本地记录，从本地获取，如果没有，使用主体列表的第一个选项)
						this.authForm.companyNameSelected = parseInt(window.localStorage.getItem('company_principal_id')) || this.companyNameList[0].id;
						this.authForm.companyCode = window.localStorage.getItem('company_code') || this.companyNameList[0].code;

					} else {
						this.personNameList = res.data.data;
						// 判断列表中是否需要新建功能
						if (this.authPrincipalCount > 0) {
							this.personNameList.push({
								id: -1,
								name: '新增个人主体',
								code: ''
							})
						}
						// 初始化主体选择和身份证号(有本地记录，从本地获取，如果没有，使用主体列表的第一个选项)
						this.authForm.personNameSelected = parseInt(window.localStorage.getItem('person_principal_id')) || this.personNameList[0].id;
						this.authForm.personCode = window.localStorage.getItem('person_code') || this.personNameList[0].code;
					}
				}
			})
		},
		//  当切换主体时
		principalChange(val) {
			this.resetAuthForm();
			this.authForm.principal = val;
			this.getAuthPrincipalList();
			// 清除表单校验结果
			this.$refs['authForm'].clearValidate();
		},
		resetAuthForm() {
			this.$set(this.authForm, 'companyNameSelected', parseInt(window.localStorage.getItem('company_principal_id') || (this.companyNameList[0] ? this.companyNameList[0].id : -2)));
			this.$set(this.authForm, 'personNameSelected', parseInt(window.localStorage.getItem('person_principal_id') || (this.personNameList[0] ? this.personNameList[0].id : -1)));
		},
		//  选择主体时，获取对应的身份证号或信用代码
		getAuthCode(id) {
			// 清除表单校验结果
			this.$refs['authForm'].clearValidate();
			// 如果点击的是新建
			if (id === -2) {
				this.authForm.companyName = '';
				this.authForm.companyCode = '';
				this.authForm.companyPhone = '';
				this.authForm.companyEmail = '';
			} else if (id === -1) {
				this.authForm.personName = '';
				this.authForm.personCode = '';
				this.authForm.personPhone = '';
				this.authForm.personEmail = '';
			} else {
				if (this.authForm.principal === '2') {
					let list = this.companyNameList;
					for (let i = 0; i < list.length; i++) {
						let item = list[i];
						if (item.id === id) {
							this.authForm.companyCode = item.code || '';
							break;
						}
					}
				} else {
					let list = this.personNameList;
					for (let i = 0; i < list.length; i++) {
						let item = list[i];
						if (item.id === id) {
							this.authForm.personCode = item.code || '';
							break;
						}
					}

				}
			}
		},
		//  点击提交
		authSubmimt() {
			this.submitClicked = true;
			this.$refs['authForm'].validate((valid) => {
				if (valid) {
					Object.keys(this.authForm).forEach(item => {
						let value = this.authForm[item];
						if (item !== "companyNameSelected" && item !== "personNameSelected") {
							this.authForm[item] = this.filterFn(value);
						}
					})

					let {
						companyCode,
						companyEmail,
						companyName,
						companyPhone,
						personCode,
						personEmail,
						personName,
						personPhone,
						principal,
						companyNameSelected,
						personNameSelected
					} = this.authForm;
					companyCode = companyCode.toUpperCase();
					personCode = personCode.toUpperCase();

					let paramterObj;
					// 根据表单的值判断是否是添加
					if (principal === "2") {
						// 如果是企业,-2为新建
						if (companyNameSelected === -2) {
							paramterObj = {
								type: 2,
								principal_id: 0,
								authorize_id: this.currentAuthorizeId,
								name: companyName,
								code: companyCode,
								phone: companyPhone,
								email: companyEmail
							}
						} else {
							for (let i = 0; i < this.companyNameList.length; i++) {
								let item = this.companyNameList[i];
								if (item.id === companyNameSelected) {
									companyName = item.name
									break;
								}
							}
							paramterObj = {
								type: 2,
								principal_id: companyNameSelected,
								authorize_id: this.currentAuthorizeId,
								name: companyName,
								code: companyCode,
							}

						}
					} else if (principal === "1") {
						// 如果是个人
						if (personNameSelected === -1) {
							paramterObj = {
								type: 1,
								principal_id: 0,
								authorize_id: this.currentAuthorizeId,
								name: personName,
								code: personCode,
								phone: personPhone,
								email: personEmail
							}
						} else {
							for (let i = 0; i < this.personNameList.length; i++) {
								let item = this.personNameList[i];
								if (item.id === personNameSelected) {
									personName = item.name
									break;
								}
							}
							paramterObj = {
								type: 1,
								principal_id: personNameSelected,
								authorize_id: this.currentAuthorizeId,
								name: personName,
								code: personCode,
							}
						}
					}
					Copyright.addAuthorize(paramterObj).then(res => {
						if (res.status == 1) {
							//  进行下载，并关闭弹窗
							this.authDownload(res.data.photo_id);
							this.authDialogVisible = false;
							//  本地存储3个值
							window.localStorage.setItem('type', res.data.type);
							res.data.type === "2" ? window.localStorage.setItem('company_principal_id', res.data.principal_id) : window.localStorage.setItem('person_principal_id', res.data.principal_id);
							res.data.type === "2" ? window.localStorage.setItem('company_code', res.data.code) : window.localStorage.setItem('person_code', res.data.code);
							
							this.initData()
							this.submitClicked = false;
						} else {
							// 关闭正在操作的弹窗
							this.authDialogVisible = false;
							//  提交失败的弹窗出现
							this.authFailDialogVisible = true;
							this.submitClicked = false;
						}
					})
				} else {
					this.submitClicked = false;
					return false;
				}
			})
		},
		//  点击授权失败弹窗的关闭或好的
		closeAuthFailDialog() {
			// 关闭弹窗并刷新页面，维持当前的页码状态
			this.authFailDialogVisible = false;
			// 重新获取当前也列表的数据
			this.getAuthData();
		},
		//  下载授权书
		authDownload(photo_id) {
			this.flag = false;
			Copyright.downloadAuthorize({ photo_id }).then(res => {
				if (res.status == 1) {
					this.staticFunc.downloadFile(res.data, photo_id)
					setTimeout(() => {
						this.flag = true
					}, 1000)
				} else {
					res.message && this.$message.error(res.message);
					setTimeout(() => {
						this.flag = true
					}, 1000)
				}
			})

		},
		filterFn(str) {
			let resultStr = str.replace(/\ +/g, ""); //去掉空格
			resultStr = resultStr.replace(/[ ]/g, ""); //去掉空格
			resultStr = resultStr.replace(/[\r\n]/g, ""); //去掉回车换行
			return resultStr
		}
	}
}
</script>
<style lang="scss" scoped>
::v-deep .el-table {
	height: 100%;
	padding: 32px 0 20px !important;
	border: none;
}

::v-deep .el-table__row td:first-of-type {
	border-left: 1px solid #F7F6F9 !important;
}
::v-deep .el-table__header-wrapper th{
	height: 30px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333;
	line-height: 30px;
}
::v-deep .el-table__row .cell{
	font-size: 12px;
	color: #666;
	line-height: 17px;
	word-break: break-word;
	overflow: initial;
	text-overflow: initial;
	white-space: initial;
}

.pages-container {
	margin-bottom: 20px;

	.el-pagination {
		text-align: center;
	}
}

.img-wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 3px 0;

	img {
		max-width: 100%;
		max-height: 48px;
	}
}

.option {
	a {
		color: #666;
	}
}

// 商业授权书弹窗
.auth-dialog-meng {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	z-index: 999;

	.auth-dialog-content {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: #ffffff;
		border-radius: 8px;
	}

	.close-img {
		position: absolute;
		display: block;
		width: 20px;
		height: 20px;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}

	#auth-dialog {
		width: 540px;
		border: 1px solid #979797;
		box-sizing: border-box;
		padding: 36px 40px;

		h1 {
			height: 30px;
			font-size: 22px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #333333;
			line-height: 30px;
			text-align: center;
			margin-bottom: 32px;
		}

		.el-form-item {
			margin-bottom: 20px;
		}

		.el-form-item__label {
			font-size: 14px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #333333;
			padding-right: 24px;
		}

		.notice-content {
			margin-bottom: 24px;
		}

		.notice-content .el-form-item__label {
			line-height: 20px;
		}

		.el-form-item__content {
			width: 326px;
		}

		.notice {
			font-size: 14px;
			font-family: PingFang-SC-Regular, PingFang-SC;
			font-weight: 400;
			line-height: 20px;
			color: #333333;
		}

		.auth-notice {
			font-size: 14px;
			font-family: PingFang-SC-Regular, PingFang-SC;
			font-weight: 400;
			color: #e54b4b;
		}

		.auth-20-line {

			.el-form-item__label,
			.el-form-item__content {
				line-height: 20px;
				height: 20px;
			}
		}

		.auth-32-line {
			margin-bottom: 32px;
		}

		.auth-52-line {
			margin-bottom: 52px;
		}

		.el-radio__label {
			font-size: 14px;
			font-family: PingFang-SC-Regular, PingFang-SC;
			font-weight: 400;
			color: #333333;
			padding-left: 8px;
		}

		.el-select {
			display: block;
		}

		.el-input {
			height: 42px;

			input::-webkit-input-placeholder {
				color: #c6c6c6;
				font-weight: 400;
			}

			input::-moz-input-placeholder {
				color: #c6c6c6;
				font-weight: 400;
			}

			input::-ms-input-placeholder {
				color: #c6c6c6;
				font-weight: 400;
			}
		}

		.el-input.is-disabled input {
			color: #c6c6c6;
		}

		.el-input__inner {
			padding: 0 30px 0 8px;
			color: #333333;
			font-weight: 400;
		}

		.btn-group {
			margin-bottom: 0;

			.el-form-item__content {
				margin-left: 216px !important;
			}

			.el-button {
				width: 110px;
				height: 40px;
				border-radius: 4px;
				border: 1px solid #7966ff;
				box-sizing: border-box;
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #7966ff;
				padding: 0;

				&:hover {
					background: #f6f5ff;
				}
			}

			.el-button--primary {
				background: #7966ff;
				border: none;
				color: #ffffff;
				margin-left: 18px;

				&:hover {
					background: #9485ff;
				}
			}
		}

		.el-select .el-input.is-focus .el-input__inner {
			border-color: #7966ff;
		}

		.el-input__inner:focus {
			border-color: #7966ff;
		}

		.el-radio__inner:hover {
			border: 1px solid #7966ff;
		}

		.el-radio__input.is-checked .el-radio__inner {
			border: 1px solid #7966ff;
			background: #fff;
		}

		.el-radio__inner::after {
			width: 6px;
			height: 6px;
			background: #7966ff;
		}

		.el-form-item__error {
			font-size: 12px;
			font-family: PingFang-SC-Regular, PingFang-SC;
			font-weight: 400;
			color: #e54b4b;
			line-height: 18px;
			padding-top: 0;
		}

		.el-form-item.is-error .el-input__inner {
			border-color: #e54b4b;
		}

		.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
			content: "";
		}
	}

	#auth-dialog-fail {
		width: 400px;
		height: 300px;

		.fail-img {
			display: block;
			width: 50px;
			height: 50px;
			margin: 77px auto 24px;
		}

		.fail-text {
			text-align: center;
			height: 22px;
			font-size: 16px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 22px;
		}

		.ok-btn {
			width: 110px;
			height: 40px;
			background: #7966ff;
			border-radius: 4px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #ffffff;
			border: none;
			margin: 50px auto 0;
			display: block;
		}
	}
}
</style>
